import styled, { keyframes } from 'styled-components';

export interface DefaultDotsProps {
  background?: string;
  color?: string;
  count?: number;
}
export const DefaultDots = ({
  background,
  color,
  count = 3
}: DefaultDotsProps) => (
  <Component _backgroundColor={background}>
    <ComponentInner>
      {Array.from({ length: count }, (_, index) => [
        `${index * 10}%`,
        `${index * 10 + 15}%`,
        `${index * 10 + 25}%`
      ]).map((frames) => (
        <Dot key={frames.toString()} _frames={frames} _color={color} />
      ))}
    </ComponentInner>
  </Component>
);

const generateKeyframes = ([first, second, third]: string[]) => keyframes`
  ${first} {
    top: 0;
  }
  ${second} {
    top: -4px;
  }
  ${third} {
    top: 0;
  }
`;

const Component = styled.div<{ _backgroundColor?: string }>`
  position: absolute;
  top: inherit;
  left: inherit;
  background-color: ${({ _backgroundColor }) => _backgroundColor};
  opacity: 0.5;
  width: 53px;
  height: 32px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.1s ease all;
  z-index: 1;
`;

const ComponentInner = styled.div`
  position: relative;
  display: flex;
`;

const Dot = styled.div<{ _frames: string[]; _color?: string }>`
  height: 5px;
  width: 5px;
  margin: 0 2px;
  border-radius: 50%;
  display: inline-block !important;
  position: relative;
  background-color: ${({ _color }) => _color};
  animation: ${({ _frames }) => generateKeyframes(_frames)} 1.2s linear infinite;
`;
